import { useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import { detectEnvironment } from '@/utils/detectEnvironment';

interface VersionResponse {
  version: string;
}

const environment = detectEnvironment();

export const useVersionPolling = () => {
  const initialVersionRef = useRef<string | null>(null);

  const query = useQuery<VersionResponse>({
    queryKey: ['version'],
    queryFn: async () => {
      const res = await fetch('/version.json', { cache: 'no-cache' });
      return res.json();
    },
    refetchOnWindowFocus: false,
    refetchInterval: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    enabled: environment !== 'local'
  });

  if (query.data?.version && !initialVersionRef.current) {
    initialVersionRef.current = query.data.version;
  }

  const hasNewVersion = Boolean(
    initialVersionRef.current &&
    query.data?.version &&
    query.data.version !== initialVersionRef.current
  );

  return {
    hasNewVersion,
    ...query
  };
};
